import { render, staticRenderFns } from "./ExamSchedule.vue?vue&type=template&id=31dd6d9f&"
import script from "./ExamSchedule.vue?vue&type=script&lang=js&"
export * from "./ExamSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports